import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@store/hooks';
import {
  setEnabled as setEnabledAction,
  selectTab as selectTabAction,
  openTab as openTabAction,
  updateCurrentTab as updateCurrentTabAction,
  closeTab as closeTabAction,
  closeLeftTabs as closeLeftTabsAction,
  closeRightTabs as closeRightTabsAction,
  closeAllTabs as closeAllTabsAction,
  ITab,
  getSelectActiveTabIndex,
  setClosedTab,
  setTabs,
  clearRecentlyClosedTabs
} from '@store/reducers/tabsSlice';

export const useTabs = () => {
  const dispatch = useAppDispatch();
  const activeTabIndex = useSelector(getSelectActiveTabIndex);

  const setEnabledTabs = useCallback(
    (isEnabled: boolean) => {
      dispatch(setEnabledAction(isEnabled));
    },
    []
  );

  const selectTab = useCallback(
    (selectedTabIndex: number) => {
      dispatch(selectTabAction(selectedTabIndex));
    },
    []
  );

  const openTab = useCallback(
    (tab: ITab) => {
      dispatch(openTabAction(tab));
    },
    []
  );

  const updateCurrentTab = useCallback(
    (tabToupdate: Partial<ITab>) => {
      dispatch(updateCurrentTabAction(tabToupdate));
    },
    []
  );

  const closeTab = useCallback(
    (tabIndexToRemove: number) => {
      dispatch(closeTabAction(tabIndexToRemove));
    },
    []
  );

  const closeLeftTabs = useCallback(
    (tabIndex: number) => {
      dispatch(closeLeftTabsAction(tabIndex));
    },
    []
  );

  const closeRightTabs = useCallback(
    (tabIndex: number) => {
      dispatch(closeRightTabsAction(tabIndex));
    },
    []
  );

  const closeAllTabs = useCallback(
    () => {
      dispatch(closeAllTabsAction());
    },
    []
  );

  const setClosedTabValue = useCallback((tab: ITab) => {
    dispatch(setClosedTab(tab));
  }, []);

  const setTabList = useCallback((tabs: ITab[]) => {
    dispatch(setTabs(tabs));
  }, []);

  const clearClosedTabs = useCallback(() => {
    dispatch(clearRecentlyClosedTabs());
  }, []);

  return {
    setEnabledTabs,
    selectTab,
    openTab,
    updateCurrentTab,
    closeLeftTabs,
    closeRightTabs,
    closeAllTabs,
    closeTab,
    setClosedTabValue,
    activeTabIndex,
    setTabList,
    clearClosedTabs
  };
};